import { AssetsService } from "app/services/AssetsService";

export const AFTER_TRIAL_MODAL_ROOT_AUTOMATION = "si-after-trial-entry-modal-root";

export const AFTER_TRIAL_DIALOG_TITLE_ID = "si-after-trial-dialog-title";

export const AFTER_TRIAL_PORTAL_CONTAINER_ID = "si-after-trial-entry-modal-portal";

export const AFTER_TRIAL_ILLUSTRATION_URL = AssetsService.assetUrl("/images/sales-intelligence/after-trial-view.svg");

export const BULLET_KEYS = [
    "si.after_trial_entry_modal.bullet.historical_data",
    "si.after_trial_entry_modal.bullet.company_overviews",
    "si.after_trial_entry_modal.bullet.contact_reveals",
    "si.after_trial_entry_modal.bullet.ai_insights",
] as const;
